<template>
  <Select
    class="pet-sex-selector__select"
    :placeholder="placeholder"
    :is-disabled="isDisabled"
    :value="selectedPetSexId"
    :options="petSexOptions"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="value"
    :error-messages="errorMessages"
    @beforeChange="onBeforeChange"
    @change="handlePetSexSelect"
  />
</template>

<script>
import { petSexLabels } from '@/entities/insurance/config/pet-sex';
import { Select } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Оберіть стать',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedPetSexId: null,
    };
  },
  mounted() {
    this.syncSelectedPetSexId(this.value);
  },
  components: { Select },
  computed: {
    petSexOptions() {
      return Object.entries(petSexLabels).map(([id, value]) => ({ id, value }));
    },
  },
  methods: {
    extractId(rawValue) {
      const raw = typeof rawValue === 'object' ? rawValue?.id : rawValue;
      return raw != null ? String(raw) : null;
    },
    syncSelectedPetSexId(newValue) {
      this.selectedPetSexId = this.extractId(newValue);
    },
    handlePetSexSelect(selectedId) {
      const normalizedId = this.extractId(selectedId);
      this.selectedPetSexId = normalizedId;
      this.$emit('input', normalizedId);
      this.$emit('change', normalizedId);
    },
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.syncSelectedPetSexId(newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.pet-sex-selector__select {
  width: 100%;
}
</style>
